import axios from 'axios';

import type {
  PhoneProfileCreateRequest,
  PhoneProfileInfo,
  PhoneProfileListResponsePhoneProfileInfo,
  PhoneProfilePatchRequest,
} from '~/server_shared/openapi/data-contracts';

export type Profile = PhoneProfileInfo;
export type ProfileListItem = PhoneProfileListResponsePhoneProfileInfo;

const phoneProfilesBase = (orgId: number): string => `/api/v1/organizations/${orgId}/phone_profiles`;

export const phoneProfileUrls = {
  list: (orgId: number) => phoneProfilesBase(orgId),
  resource: (orgId: number, id: number) => `${phoneProfilesBase(orgId)}/${id}`,
  promoteDefault: (orgId: number, id: number) => `${phoneProfilesBase(orgId)}/${id}/default`,
  outboundConfig: (orgId: number, id: number) =>
    `${phoneProfilesBase(orgId)}/${id}/outbound_phone_message_configuration`,
  inboundConfig: (orgId: number, id: number) => `${phoneProfilesBase(orgId)}/${id}/inbound_phone_message_configuration`,
  voicemailConfig: (orgId: number, id: number) => `${phoneProfilesBase(orgId)}/${id}/voicemail_configuration`,
} as const;

export const createPhoneProfile = async (
  orgId: number,
  payload: PhoneProfileCreateRequest
): Promise<PhoneProfileInfo> => {
  const { data } = await axios.post<PhoneProfileInfo>(phoneProfileUrls.list(orgId), payload);
  return data;
};

export const updatePhoneProfile = async (
  orgId: number,
  id: number,
  payload: PhoneProfilePatchRequest
): Promise<PhoneProfileInfo> => {
  const { data } = await axios.patch<PhoneProfileInfo>(phoneProfileUrls.resource(orgId, id), payload);
  return data;
};

export const deletePhoneProfile = async (orgId: number, id: number): Promise<void> => {
  await axios.delete(phoneProfileUrls.resource(orgId, id));
};

export const promotePhoneProfileToDefault = async (orgId: number, id: number): Promise<PhoneProfileInfo> => {
  const { data } = await axios.post<PhoneProfileInfo>(phoneProfileUrls.promoteDefault(orgId, id));
  return data;
};
